import { Controller } from "@hotwired/stimulus"

// Reusable copy-to-clipboard button. Copies `data-clipboard-text-value`
// on click and briefly swaps a copy icon for a check mark to confirm.
// Falls back to a hidden-textarea + execCommand on non-secure (http)
// origins where navigator.clipboard is unavailable.
export default class extends Controller {
  static values = { text: String }
  static targets = ["copyIcon", "doneIcon", "doneLabel"]

  connect() {
    this._title = this.element.getAttribute("title")
  }

  disconnect() {
    if (this._timer) clearTimeout(this._timer)
  }

  async copy(event) {
    event.preventDefault()
    event.stopPropagation()
    const text = (this.textValue || "").trim()
    if (!text) return

    let ok = false
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text)
        ok = true
      } else {
        ok = this._legacyCopy(text)
      }
    } catch (e) {
      ok = this._legacyCopy(text)
    }
    if (ok) this._confirm()
  }

  _legacyCopy(text) {
    const ta = document.createElement("textarea")
    ta.value = text
    ta.setAttribute("readonly", "")
    ta.style.position = "fixed"
    ta.style.opacity = "0"
    document.body.appendChild(ta)
    ta.select()
    let ok = false
    try {
      ok = document.execCommand("copy")
    } catch (_) {
      ok = false
    }
    document.body.removeChild(ta)
    return ok
  }

  _confirm() {
    if (this.hasCopyIconTarget && this.hasDoneIconTarget) {
      this.copyIconTarget.classList.add("hidden")
      this.doneIconTarget.classList.remove("hidden")
      if (this.hasDoneLabelTarget) this.doneLabelTarget.classList.remove("hidden")
    }
    this.element.setAttribute("title", "Copied!")
    if (this._timer) clearTimeout(this._timer)
    this._timer = setTimeout(() => {
      if (this.hasCopyIconTarget && this.hasDoneIconTarget) {
        this.doneIconTarget.classList.add("hidden")
        if (this.hasDoneLabelTarget) this.doneLabelTarget.classList.add("hidden")
        this.copyIconTarget.classList.remove("hidden")
      }
      this.element.setAttribute("title", this._title || "Copy")
    }, 1200)
  }
}
